import { BackgroundColors, BorderColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const InformationContainer = styled.div`
	padding: 24px;
	border: 1px solid ${BorderColors.Secondary};
	border-radius: ${BorderRadius.XL}px;
	background-color: ${BackgroundColors.PrimaryAlt};
`;

export { InformationContainer };
